import React from "react";
import { Icon } from "@shopify/polaris";
import { AlertMinor } from "@shopify/polaris-icons";

const CustomErrorWrapper = ({ error }) => {
  return (
    <div className={"Polaris-InlineError"}>
      <div className={"Polaris-InlineError__Icon"}>
        <Icon
          source={AlertMinor}
          color="critical"
        />
      </div>
      {error}
    </div>
  );
};

export default CustomErrorWrapper;